import axios from "axios";

const CALCULATE_HOURS_URL =
  process.env.NODE_ENV === "production"
    ? `${window.location.origin}/calculate`
    : "http://localhost:5000/calculate";

export const calculateHours = async (payload) => {
  try {
    const response = await axios.post(CALCULATE_HOURS_URL, payload, {
      headers: { "Content-Type": "application/json" },
    });
    return { success: true, data: response.data };
  } catch (error) {
    console.error("Hours API error:", error.response?.data || error.message);
    const status = error.response?.status;
    if (status === 400)
      return { success: false, error: error.response?.data?.error };
    return {
      success: false,
      error: "Failed to calculate hours-based emissions.",
    };
  }
};
